import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobeacrobatreaderComponent } from './simple-icons-adobeacrobatreader.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobeacrobatreaderComponent ],
    exports:      [ SimpleIconsAdobeacrobatreaderComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobeacrobatreaderModule {}
